import React, {useEffect, useState} from "react";
import styled, { css } from 'styled-components';
import 'react-dropdown/style.css';
import { PreferencesAndSubscriptionsCard } from "../PreferencesAndSubscriptionsCard";
import {UseAppSelector} from "../../redux/configure-store";
import useLocalizePhrase from "../../utils/useLocalizePhrase";
import {
    getIsSaveOrUpdateClientProfileRejected,
    getIsSaveOrUpdateRiSimulationRejected,
    getIsSavePhoneNumberRejected, getIsSavePrefAndSubCallRejected,
    getIsSaveRixSalaryPayFrequencyRejected,
    getIsShowOrHideOtherRetirementPlansRejected,
    getIsUpdateCompensationsRejected,
    getIsUpdateEmailAddressRejected,
    getIsUpdatePhoneNumberRejected
} from "../../redux/profile/selectors";


const StyledOuterContainer = styled.div`
  width: 100%;
`;

const StyledHeaderContainer = styled.div`
  background-image: linear-gradient(to bottom, #054c70 0%, #002f48 83%, #002f48 100%)
`;

const StyledInnerHeaderContainer = styled.div`
  max-width: 1264px;
  margin: 0 auto;
  padding: 0 88px 95px;
  box-sizing: content-box;
  @media (max-width: 768px) {
    padding: 0  32px 95px;
  }
  @media (min-width: 768px) and (max-width: 1024px){
    padding: 0 48px 95px;
  }
`;

const StyledInnerContainer = styled.div`
  max-width: 1264px;
  margin: 0 auto;
  padding: 0  88px 48px;
  display: flex;
  flex-direction: row;
  box-sizing: content-box;
  @media (min-width: 768px) and (max-width: 1024px){
    padding: 0 48px 48px;
  }
  @media (max-width: 768px) {
    padding: 0  32px 50px;
  }
  @media (max-width: 640px) {
    flex-direction: column;
    padding: 0 24px 68px;
  }
`;
const StyledContainer = styled.div`
  background-color: #f4f5f6;
`;
const StyledNotice = styled.div`
  background-color: #f4f5f6;
  padding: 32px 88px 600px !important;
  @media (min-width: 768px) and (max-width: 1024px){
    padding: 32px 48px 0;
  }
  @media (max-width: 768px) {
    padding: 24px 32px 500px !important;
  }
  @media (max-width: 640px) {
    padding: 24px 24px 300px !important;
  }
`;
const StyledDisclaimerContainer = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 32px 40px;
  border-radius: 4px;
  border: solid 1px #dd3636;
  background-color: rgba(221, 54, 54, 0.08) ;
  font-family: "Nimbus Sans Novus Regular";
  font-size: 18px;
  line-height: 1.2;
  letter-spacing: 0.02px;
  color: #3b4b59;
  box-sizing: content-box;
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
    padding: 24px 16px;
  }
`;
const StyledErrorMobileLink = styled.a`
  color: #086ea1;
  text-decoration: underline;
`;
const StyledMainContainer = styled.div`
      width: 100%;
      box-sizing: border-box;
      margin-top: -85px;
      @media (max-width: 768px) {
        padding-right: 8px;
      }
      @media only screen and (max-width: 640px) {
        width: auto;
        padding-right: 0;
      }
`;

const HeaderText = styled.div`
  opacity: 0.9;
  font-family: "Nimbus Sans Novus Regular";
  font-weight: normal;
  color: #FFFFFF;
  padding-top: 56px;
  font-size: 56px;
  line-height: 1.15;
  letter-spacing: normal;
  div {
    display: inline;
  }
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;


export default  () => {
  const preferencesAndSubscriptionsTitle = useLocalizePhrase('Preferences & Subscriptions');
    const isUpdatePhoneNumberRejected = UseAppSelector(getIsUpdatePhoneNumberRejected);
    const isSavePhoneNumberRejected = UseAppSelector(getIsSavePhoneNumberRejected);
    const isUpdateEmailAddressRejected = UseAppSelector(getIsUpdateEmailAddressRejected);
    const isSaveOrUpdateClientProfileRejected = UseAppSelector(getIsSaveOrUpdateClientProfileRejected);
    const isUpdateCompensationsRejected = UseAppSelector(getIsUpdateCompensationsRejected);
    const isSaveRixSalaryPayFrequencyRejected = UseAppSelector(getIsSaveRixSalaryPayFrequencyRejected);
    const isSaveOrUpdateRiSimulationRejected = UseAppSelector(getIsSaveOrUpdateRiSimulationRejected);
    const isShowOrHideOtherRetirementPlansRejected = UseAppSelector(getIsShowOrHideOtherRetirementPlansRejected);
    const isSavePrefAndSubCallRejected = UseAppSelector(getIsSavePrefAndSubCallRejected);

    const isApiRejected = isUpdatePhoneNumberRejected || isSavePhoneNumberRejected ||
        isUpdateEmailAddressRejected || isSaveOrUpdateClientProfileRejected || isUpdateCompensationsRejected ||
        isSaveRixSalaryPayFrequencyRejected || isSaveOrUpdateRiSimulationRejected || isShowOrHideOtherRetirementPlansRejected ||
        isSavePrefAndSubCallRejected;

    /**
     * Function for instantiating and dispatching a JavaScript CustomEvent for
     * signaling a page load in a single page web application that does not make
     * use of hash or pop/push state changes.
     * @param {String} page - Pipe delimited String containing 1 to 4 items representing
     * the hierarchy and name of the page within the given application.
     */

    const dispatchPageLoad = (page: String) => {
        try {
            const event = new CustomEvent("pageLoad", {
                detail: {
                    page: page
                }
            });
            document.body.dispatchEvent(event);
        } catch (e) {
        }
    }

    useEffect(() => {
        const page = "Preferences";
        dispatchPageLoad(page);
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            {
                <StyledOuterContainer id={`preference-container`}>
                    <StyledHeaderContainer>
                        <StyledInnerHeaderContainer>
                            <HeaderText >
                              {preferencesAndSubscriptionsTitle}
                            </HeaderText>
                        </StyledInnerHeaderContainer>
                    </StyledHeaderContainer>

                    <StyledContainer>
                        {isApiRejected ?
                            (<StyledNotice>
                                <StyledDisclaimerContainer>
                                    {` We are sorry, but your request cannot be completed at this time. Please try again later. If you continue to receive this message, please call us at `}
                                    <StyledErrorMobileLink
                                        href="tel:+1800-922-9945">800-922-9945</StyledErrorMobileLink>{`.`}
                                </StyledDisclaimerContainer>
                            </StyledNotice>)
                            :
                            <StyledInnerContainer>
                                <StyledMainContainer>
                                    <PreferencesAndSubscriptionsCard/>
                                </StyledMainContainer>
                            </StyledInnerContainer>
                        }
                    </StyledContainer>
                </StyledOuterContainer>
            }
        </>
    );
};

